<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html{
  margin: 0;
  padding: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  height: 100%;
}
/*.el-menu-item{*/
  /*background: #000c17!important;*/
/*}*/
body, html {
  width: 100%;
  height: 100%;
}
.el-tag--danger {
    background-color: #f56c6c;
    border-color: #f56c6c;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue